import { create } from 'zustand'

import { getMessages, LocaleKey, setLocale } from './locale'

type StoreGetters = {
  authToken: string | null
  authLoaded: boolean
  guestId: string | null
  isImpersonating: boolean
  roles: string[] | null,
  partnerIri: string | null,
  localeLoaded: boolean,
  locale: LocaleKey | null,
  messages: Record<string, unknown> | null,
  userLoaded: boolean,
  partnerInterceptor: null,
  partnerType: string | null,
  partnerLocale: LocaleKey | null,
  partnerUserConfig: Record<string, any> | null
}

type StoreSetters = {
  setLocale: (locale: LocaleKey) => Promise<void>
  setAuthToken: (authToken: string) => void
  setAuthLoaded: (authLoaded: boolean) => void
  setGuestId: (guestId: string) => void
  setIsImpersonating: (isImpersonating: boolean) => void
  setUserLoaded: (userLoaded: boolean) => void
  setRoles: (roles: string[]) => void
  setPartnerIri: (partnerIri: string) => void
  setPartnerType: (partnerType: string) => void
  setPartnerInterceptor: (partnerInterceptor: any) => void
  setPartnerLocale: (partnerLocale: LocaleKey) => void
  setPartnerUserConfig: (partnerUserConfig: Record<string, any>) => void
}
type Store = StoreGetters & StoreSetters

const getInitialState = () =>
  ({
    authToken: null,
    authLoaded: false,
    guestId: null,
    isImpersonating: false,
    roles: null,
    partnerIri: null,
    localeLoaded: false,
    locale: null,
    messages: null,
    userLoaded: false,
    partnerInterceptor: null,
    partnerType: null,
    partnerLocale: null,
    partnerUserConfig: null
  }) satisfies StoreGetters

export default create<Store>(
  (set) => ({
    ...getInitialState(),
    setLocale: async (locale) => {
      set({
        localeLoaded: false,
        locale
      })

      await setLocale(locale)
      let messages = await getMessages(locale)

      if (locale !== 'en') {
        const defaultMessages = await getMessages('en')
        messages = { ...defaultMessages, ...messages }
      }

      set({
        localeLoaded: true,
        messages
      })
    },
    setAuthToken: (authToken) => {
      set({ authToken })
    },
    setAuthLoaded: (authLoaded) => {
      set({ authLoaded })
    },
    setIsImpersonating: (isImpersonating) => {
      set({ isImpersonating })
    },
    setUserLoaded: (userLoaded) => {
      set({ userLoaded })
    },
    setRoles: (roles) => {
      set({ roles })
    },
    setPartnerIri: (partnerIri) => {
      set({ partnerIri })
    },
    setPartnerInterceptor: (partnerInterceptor) => {
      set({ partnerInterceptor })
    },
    setPartnerLocale: (partnerLocale) => {
      set({ partnerLocale })
    },
    setPartnerType: (partnerType) => {
      set({ partnerType })
    },
    setGuestId: (guestId) => {
      set({ guestId })
    },
    setPartnerUserConfig: (partnerUserConfig) => {
      set({ partnerUserConfig })
    }
  })
)
